// Normalizes one workflow status into its comparison key.
const read_status_key = (value = '') => {
    return `${value || ''}`.trim().toLowerCase().replace(/[\s-]+/g, '_');
};

// Reads the board status used to decide whether a workflow label is relevant.
const read_board_status = (offerItem = {}) => {
    return read_status_key(
        offerItem?.setupData?.sassBoardStatus
        || offerItem?.typesData?.sassBoardStatus
        || offerItem?.sassBoardStatus
        || offerItem?.status
    );
};

// Exposes only user-actionable SASS workflow states instead of raw sync transport state.
export const read_sass_workflow_status = (offerItem = {}) => {
    const boardStatus = read_board_status(offerItem);
    const statuses = [
        offerItem?.connection?.syncState?.status,
        offerItem?.workflow?.nifflerConnection?.status,
        offerItem?.workflow?.cerebroConnection?.status,
        offerItem?.workflow?.sassPayment?.status
    ].map(read_status_key).filter(Boolean);
    const failureStatuses = ['failed', 'error', 'retry_failed', 'sync_failed', 'blocked'];
    const hasFailure = statuses.some((status) => failureStatuses.includes(status));
    const waitingForActiveQuest = boardStatus === 'paid' && statuses.includes('waiting_for_active_quest');
    const syncPending = offerItem?.syncPending === true || statuses.includes('pending');
    const state = [
        [hasFailure, 'failed'],
        [waitingForActiveQuest, 'waiting'],
        [syncPending, 'pending']
    ].find((stateItem) => stateItem[0])?.[1] || 'hidden';
    const statusLookup = {
        failed: { label: 'Sync failed', tone: 'error' },
        waiting: { label: 'Waiting for active quest', tone: 'warning' },
        pending: { label: 'Saved, sync pending', tone: 'warning' },
        hidden: { label: '', tone: '' }
    };

    return statusLookup[state];
};
